import { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/variant-model';
import {
  buildValidations,
  disabledWhenVariant,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  headline: validator('presence', true),
  category: [
    validator('belongs-to'),
    validator('presence', {
      presence: true,
      disabled: disabledWhenVariant(),
    }),
  ],
});

export const settings = {
  copyableOptions: {
    ignoreAttributes: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'ownedByChannel',
    ],
  },
  variantProperties: ['cmsLanguageId', 'cmsState', 'headline', 'text'],
};

export default class TeaserModel extends Model.extend(Validations) {
  @attr('string') headline;
  @attr('string') text;
  @attr('string') socialMediaId;
  @attr('string') entitySubtype;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @hasMany('artist', { async: true, inverse: null }) artists;
  @belongsTo('asset', { async: true, inverse: null }) asset;
  @belongsTo('asset', { async: true, inverse: null }) backgroundImage;
  @belongsTo('category', { async: true, inverse: null }) category;
  @hasMany('channel', { async: true, inverse: null }) channelsAdditive;
  @hasMany('channel', { async: true, inverse: null }) channelsExcluded;
  @hasMany('channel', { async: true, inverse: null }) channelsExclusive;
  @belongsTo('link', { async: true, inverse: null }) link;
  @hasMany('asset', { async: true, inverse: null }) youniverseStageAssets;
  @hasMany('asset', { async: true, inverse: null }) youniverseScreenAssets;
  @hasMany('taxon', { async: true, inverse: null }) taxa;

  // Getter and setter
  get displayHeadline() {
    return this.headline;
  }

  get displayLabel() {
    return this.headline;
  }
}
